var _rect, _rect2, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(90 23.5 0.5)",
    fill: "#FFB72B",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(90 23.5 0.5)",
    stroke: "#FFB72B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 7.17647,
    rx: 1.41176,
    ry: 1.5,
    transform: "rotate(90 12 7.17647)",
    fill: "#FFB72B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 1.41176,
    ry: 1.5,
    transform: "rotate(90 12 12)",
    fill: "#FFB72B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 16.8235,
    rx: 1.41176,
    ry: 1.5,
    transform: "rotate(90 12 16.8235)",
    fill: "#FFB72B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMoreIcon);
export default __webpack_public_path__ + "static/media/ActiveMoreIcon.8e2963635a871313cab93ed2c647b5ed.svg";
export { ForwardRef as ReactComponent };